import { useSettings } from "@/context/SettingsContext";
import { goUrl, trackClick } from "@/lib/api";
import { ExternalLink, LifeBuoy } from "lucide-react";

const CATEGORY_LABEL = {
  sport: "Sport",
  casino: "Casinò",
  virtual: "Virtual",
  slot: "Slot & Games",
};

export default function PromoCard({ promo, bookmakerName }) {
  const s = useSettings();
  return (
    <article
      data-testid={`promo-card-${promo.id}`}
      className="relative flex flex-col rounded-2xl border border-white/10 bg-[#111111] p-6 transition-colors duration-200 hover:border-yellow-400/40"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-[10px] font-bold uppercase tracking-widest text-yellow-400 bg-yellow-400/10 border border-yellow-400/25 px-2.5 py-1 rounded-full">
          {CATEGORY_LABEL[promo.category] || promo.category}
        </span>
        {promo.is_new && (
          <span className="text-[10px] font-bold uppercase tracking-widest text-black bg-yellow-400 px-2.5 py-1 rounded-full">
            Nuova
          </span>
        )}
      </div>

      <h3 className="text-lg font-bold text-white leading-tight mb-1">
        {promo.title}
      </h3>
      <p className="text-xs uppercase tracking-widest text-zinc-500 mb-3">
        {bookmakerName || promo.bookmaker_slug}
      </p>

      {promo.max_amount && (
        <div className="mb-3">
          <div className="text-[11px] uppercase tracking-widest text-zinc-500">
            Fino a
          </div>
          <div className="text-2xl font-black text-yellow-400 tracking-tight">
            {promo.max_amount}
          </div>
        </div>
      )}

      <p className="text-sm text-zinc-400 mb-4 leading-relaxed">
        {promo.description}
      </p>

      {promo.conditions?.length > 0 && (
        <ul className="mb-5 space-y-1.5 text-sm text-zinc-300">
          {promo.conditions.slice(0, 4).map((c, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-yellow-400 shrink-0" />
              <span>{c}</span>
            </li>
          ))}
        </ul>
      )}

      {promo.valid_until && (
        <div className="text-xs text-zinc-500 mb-4">
          Valida fino al {promo.valid_until}
        </div>
      )}

      <div className="mt-auto flex flex-col sm:flex-row gap-2">
        <a
          href={goUrl(promo.bookmaker_slug)}
          target="_blank"
          rel="noreferrer noopener"
          data-testid={`promo-signup-${promo.id}`}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold text-sm px-4 py-3 transition-transform duration-200 hover:scale-[1.02]"
        >
          Registrati <ExternalLink className="w-4 h-4" />
        </a>
        <a
          href={s.whatsapp_url}
          target="_blank"
          rel="noopener"
          onClick={() => trackClick("whatsapp")}
          data-testid={`promo-help-${promo.id}`}
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 hover:border-yellow-400 hover:text-yellow-400 text-white font-medium text-sm px-4 py-3 transition-colors duration-200"
        >
          <LifeBuoy className="w-4 h-4" /> Assistenza
        </a>
      </div>
    </article>
  );
}
